import { useRef, } from 'react';
import BaseFiles, { BaseFilesProps } from '../../utilsTsx/components/files/BaseFiles';
import systematic from '../../config/systematic';

const Files = (props: any) => {
    const ref = useRef<any>(undefined);
    const extendProps: BaseFilesProps = {
        defaultService: systematic.bmService
    }

    return (
        <>
            <BaseFiles {...extendProps} ref={ref} />
        </>
    )
}

export default Files;